<section class="container mx-auto p-4">
  <div class="flex flex-row justify-between items-start mt-4 mb-6">
    <h2 class="text-2xl font-semibold">{{ "hierarchy_title" | i18n }}</h2>
    <mat-icon (click)="onClose()"
      class="pointer !flex items-center justify-center !text-[24px] cursor-pointer hover:opacity-70">close</mat-icon>
  </div>

  <div [formGroup]="treeForm" class="flex flex-col lg:flex-row justify-between gap-5 hierarchy-container">
    <div class="w-full lg:w-1/2 order-2 lg:order-1 flex flex-col items-start gap-5 self-stretch">
      <mat-card class="line-right fleets w-full p-4 h-full mat-custom-card mat-custom-card-shadow">
        <mat-form-field class="w-full">
          <input matInput placeholder="" [attr.disabled]="true" formControlName="filterTree" />
          <rfc-icon matSuffix [iconInput]="setIconAttributeForRendering()"></rfc-icon>
        </mat-form-field>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <ul class="list-none p-0">
              <li class="flex items-center py-1">
                <mat-checkbox class="checklist-leaf-node" (change)="todoItemSelectionToggle($event.checked, node)"
                  [checked]="node.selected">
                  <strong class="font-bold">{{ node.idRef }}</strong> - {{ node.name }}
                </mat-checkbox>
              </li>
            </ul>
          </mat-tree-node>

          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <ul class="list-none p-0">
              <li>
                <div class="flex items-center py-1">
                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror !flex items-center justify-center">
                      {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="node.selected" [indeterminate]="node.indeterminate && !node.selected"
                    (change)="todoItemSelectionToggle($event.checked, node)">
                    <strong class="font-bold">{{ node.idRef }}</strong> - {{ node.name }}
                  </mat-checkbox>
                </div>
                <ul class="pl-8" [class.hidden]="!treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </ul>
          </mat-nested-tree-node>
        </mat-tree>
      </mat-card>
    </div>

    <div class="w-full lg:w-1/2 order-1 lg:order-2 self-stretch">
      <mat-card class="fleets w-full p-4 h-full mat-custom-card mat-custom-card-shadow">
        <div class="flex flex-row items-center w-full">
          <strong class="text-lg">
            {{ "selected_hierarchy" | i18n }} : {{ treeHierarchy?.length }}
          </strong>
        </div>
        <div class="flex flex-row items-center w-full mt-4">
          <ul class="fleets-selected list-none p-0 w-full">
            <li *ngFor="let item of treeHierarchy; let i = index" class="py-1 border-b border-gray-100 last:border-0">
              {{ getResultToShow(item) }}
            </li>
          </ul>
        </div>
      </mat-card>
    </div>
  </div>

  <div class="flex flex-col sm:flex-row justify-center items-center gap-8 mt-8 mb-4">
    <button mat-raised-button class="btnstyle w-full sm:w-auto" (click)="clear()">
      {{ "clear_fleet_selected" | i18n }}
    </button>
    <button mat-raised-button class="btnstyle w-full sm:w-auto" (click)="submit()" [disabled]="isSubmitDisabled()">
      {{ "selected_fleets" | i18n }}
    </button>
  </div>
</section>